import React from 'react'
import {Toast} from 'react-onsenui'
import {connect} from "react-redux";
import {hideToastMessage} from "../../modules/toast";

class ToastMessage extends React.Component {
    constructor(props) {
        super(props);
    }

    state = {
    };

    componentDidMount(){
    }

    componentWillReceiveProps(nextProps) {
    }


    componentWillMount() {
    }

    render() {
        return (
           <div>
               {
                   this.props.showToast ?
                       <Toast isOpen={this.props.toastMessage !== null} className="toast-wrapper" onClick={() => this.props.hideToastMessage()} >
                           <div className="message" style={{width: '80%'}}>
                               {this.props.toastMessage}
                           </div>
                           <button style={{color: '#55acee'}}>
                               닫기
                           </button>
                       </Toast>
                       :
                       null
               }
           </div>
        )
    }
}

const mapStateToProps = ({ toast }) => ({
    showToast: toast.showToast,
    toastMessage: toast.toastMessage
});

const mapDispatchToProps = dispatch => ({
    hideToastMessage: () => dispatch(hideToastMessage())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ToastMessage)